export const decodePath = (path) => {
  return window.google.maps.geometry.encoding.decodePath(path);
}

export const calculateSize = (path) => {
  const conversionConstant = 4046.85642; // square meter to acres
  return (window.google.maps.geometry.spherical.computeArea(path) / conversionConstant).toFixed(2);
}

export const encodePath = (path) => {
  return window.google.maps.geometry.encoding.encodePath(path);
}

export const fitMapToShapes = (fields, map, center) => {
  if ((fields.length === 1 && !fields[0].boundary) && center) {
    recenterMap(center, map);
    return;
  }
  if (map && (map.fitBounds && fields)) {
    const bounds = new window.google.maps.LatLngBounds();
    fields.forEach((field) => {
      if (field.decodedPath) {
        field.decodedPath.forEach((path) => {
          bounds.extend(path);
        });
      }
    });
    map.fitBounds(bounds, {left:330});
  }
  return;
}

export const addEventsToShapes = (shape, func) => {
  shape.addListener('dragend', () => {
    func(shape);
  });
  // shape.addListener('click', () => {
  //   func(shape);
  // });
  shape.addListener('mouseup', () => {
    func(shape);
  });
  shape.getPath().addListener('insert_at', () => {
    func(shape);
  })
  shape.getPath().addListener('set_at', () => {
    func(shape);
  });
  shape.getPath().addListener('remove_at', () => {
    func(shape);
  });
}

export const clearMap = (shapes) => {
  if (shapes.length === 0) return;
  shapes.forEach(shape => {
    shape.setMap(null);
  });
}

export const recenterMap = (data, map) => {
  if (map) {
    const { maps } = window.google;
    let center = new maps.LatLng(data.lat, data.lng);
    map.panTo(center);
  }
}

const latLng2point = (latLng) => {
  return {
    x: (latLng.lng + 180) * (256 / 360),
    y: (256 / 2) - (256 * Math.log(Math.tan((Math.PI / 4) + ((latLng.lat * Math.PI / 180) / 2))) / (2 * Math.PI))
  };
}


/**
 * converts boundries of polygons to svg paths
 * @param {array} gmPaths 
 */
const polygonToSVG = (gmPaths) => {
  let point;
  let svgPaths = [];
  let  minX = 256;
  let  minY = 256;
  let  maxX = 0;
  let  maxY = 0;

  for (var pp = 0; pp < gmPaths.length; ++pp) {
    point = latLng2point(gmPaths[pp]);
    minX = Math.min(minX, point.x);
    minY = Math.min(minY, point.y);
    maxX = Math.max(maxX, point.x);
    maxY = Math.max(maxY, point.y);
    svgPaths.push(`${point.x}, ${point.y}`)
  }
  return {
    path: 'M' + svgPaths.join(' ') + 'z',
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}

export const decodeFieldPaths = (fields) => {
  const fieldsWithDecodedPath = fields.map((field) => {
    if (field.boundary) {
      const decodedPath = decodePath(field.boundary);
      field.decodedPath = decodedPath;
      const latlng = decodedPath.map((path) => {
        return {
          lat: path.lat(),
          lng: path.lng()
        }
      });
      const result = polygonToSVG(latlng);
      field.svg = result;
      field.size = calculateSize(decodedPath);
      return field;
    }
    return field;
  });
  return fieldsWithDecodedPath;
}

export const setShapeOptions = (shape, options = {}) => {
  if (options && typeof options === 'object' && !Array.isArray(options)) {
    shape && shape.setOptions(options);
  }
}

